import React from 'react';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  background?: 'white' | 'light' | 'dark' | 'accent';
}
export function Section({
  children,
  className = '',
  id,
  background = 'white'
}: SectionProps) {
  const backgrounds = {
    white: 'bg-white text-slate-900',
    light: 'bg-slate-50 text-slate-900',
    dark: 'bg-slate-900 text-slate-50',
    accent: 'bg-indigo-900 text-white'
  };
  return <section id={id} className={`py-16 md:py-24 px-4 sm:px-6 lg:px-8 ${backgrounds[background]} ${className}`} data-id="element-222">
      <div className="max-w-3xl mx-auto" data-id="element-223">{children}</div>
    </section>;
}